import React, { useState, useEffect } from 'react'
import { getTextShort, formatDate } from '@helpers/helper.novelty'
import { Novelty, RealEstateDataPageComponentData } from 'types'
import { Link } from 'gatsby'

type Props = {
  skeleton: boolean
  isHome: boolean
  novelty: Novelty
  dispatch: any
  isSummaryCard: boolean
  placeholder?: string
  upperCaseLink?: boolean
  dateFormat?: 'long' | 'short'
  forceSquare?: boolean
}

const NoveltyCard_4 = (props: Props & RealEstateDataPageComponentData) => {
  const isHome = props?.isHome
  const dateFormat = props?.dateFormat
  const upperCaseLink = props?.upperCaseLink
  const placeholder = props?.placeholder
  const { darkMode } = props.global_data?.content.cardsNovelties.data

  const {
    novelty,
    skeleton,
    forceSquare,
    isSummaryCard,
    global_data: { divisionPath },
  } = props

  const noveltyPath = novelty?.id
    ? `${divisionPath ?? ''}/novedad/${novelty.id}/${novelty.slug}`
    : '/'

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <Link
      to={noveltyPath}
      className="link-card"
    >
      <div
        className={
          'novelty-card b cursor-pointer d-flex flex-column flex-lg-row justify-content-end align-items-center ' +
          (isSummaryCard ? ' summary-card ' : '') +
          (isHome ? 'home' : '') +
          (skeleton ? ' skeleton ' : '') +
          (forceSquare ? ' squareMode ' : '') +
          (darkMode ? ' background-primary ' : '')
        }
      >
        <img
          src={novelty?.image}
          alt=""
        />
        {isMounted ? (
          <div className="div-content d-flex flex-column p-5 text-start justify-content-center">
            <div className="div_texto">
              <span className="date text-uppercase">
                {formatDate(novelty?.date_published, dateFormat ? dateFormat : '')}
              </span>
              <h2 className="title mt-5 mb-4">{getTextShort(novelty?.title, isHome ? 40 : 40)}</h2>
            </div>
            <div className="div_button col-12 d-lg-flex">
              <div className={'btn btn-primary' + (upperCaseLink ? ' text-uppercase' : '')}>
                {placeholder ? placeholder : 'Ver más'}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </Link>
  )
}

export default NoveltyCard_4
